import {
    SET_TRATAMIENTO,
    SET_SEXO,
    SET_NOMBRE_COMPRAMOS_TU_AUTO,
    SET_APELLIDO_PATERNO_COMPRAMOS_TU_AUTO,
    SET_ESTADO_COMPRAMOS_TU_AUTO,
    SET_CIUDAD_COMPRAMOS_TU_AUTO,
    SET_ID_CONCESIONARIO_COMPRAMOS_TU_AUTO,
    SET_CONCESIONARIO_COMPRAMOS_TU_AUTO,
    SET_TELEFONO_COMPRAMOS_TU_AUTO,
    SET_MOVIL_COMPRAMOS_TU_AUTO,
    SET_CORREO_COMPRAMOS_TU_AUTO,
    SET_ANO_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    SET_MODELO_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    SET_COLOR_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    SET_MARCA_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    SET_VERSION_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    SET_KILOMETRAJE_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    SET_COMENTARIOS_COMPRAMOS_TU_AUTO,
    SET_AVISO_PRIVACIDAD_COMPRAMOS_TU_AUTO,
    SET_TERMINOS_Y_CONDICIONES_COMPRAMOS_TU_AUTO,
    SET_LEGALES_COMPRAMOS_TU_AUTO,
    SET_URL_HOME_DEALER_COMPRAMOS_TU_AUTO,
    RESET_STATE_COMPRAMOS_TU_AUTO,
} from "../types";

/**
* Función para reiniciar el state
* @returns
*/
export function reiniciarStateAction() {
    return async (dispatch) => {
        dispatch({ type: RESET_STATE_COMPRAMOS_TU_AUTO });
    };
}

/**
 *
 * @param {*} inTratamiento
 * @returns
 */
export function setTratamientoAction(inTratamiento) {
    const sexo = inTratamiento === "Sr" ? "Masculino" : "Femenino";
  
    return (dispatch) => {
      dispatch(setTratamiento(inTratamiento));
      dispatch(setSexo(sexo));
    };
  }
  const setTratamiento = (inTratamiento) => ({
    type: SET_TRATAMIENTO,
    payload: inTratamiento,
  });
  const setSexo = (inSexo) => ({
    type: SET_SEXO,
    payload: inSexo,
  });
  
/**
*
* @param {*} inNombre
* @returns
*/
export function setNombreAction(inNombre) {
    return (dispatch) => {
        dispatch(setNombre(inNombre));
    };
}
const setNombre = (inNombre) => ({
    type: SET_NOMBRE_COMPRAMOS_TU_AUTO,
    payload: inNombre,
});

/**
 *
 * @param {*} inApellidoPaterno
 * @returns
 */
export function setApellidoPaternoAction(inApellidoPaterno) {
    return (dispatch) => {
        dispatch(setApellidoPaterno(inApellidoPaterno));
    };
}
const setApellidoPaterno = (inApellidoPaterno) => ({
    type: SET_APELLIDO_PATERNO_COMPRAMOS_TU_AUTO,
    payload: inApellidoPaterno,
});

/**
 *
 * @param {*} inTelefono
 * @returns
 */
export function setTelefonoAction(inTelefono) {
    return (dispatch) => {
        dispatch(setTelefono(inTelefono));
    };
}
const setTelefono = (inTelefono) => ({
    type: SET_TELEFONO_COMPRAMOS_TU_AUTO,
    payload: inTelefono,
});

/**
 *
 * @param {*} inMovil
 * @returns
 */
export function setMovilAction(inMovil) {
    return (dispatch) => {
        dispatch(setMovil(inMovil));
    };
}
const setMovil = (inMovil) => ({
    type: SET_MOVIL_COMPRAMOS_TU_AUTO,
    payload: inMovil,
});

/**
 *
 * @param {*} inCorreo
 * @returns
 */
export function setCorreoAction(inCorreo) {
    return (dispatch) => {
        dispatch(setCorreo(inCorreo));
    };
}
const setCorreo = (inCorreo) => ({
    type: SET_CORREO_COMPRAMOS_TU_AUTO,
    payload: inCorreo,
});

/**
 *
 * @param {*} inEstado
 * @returns
 */
export function setEstadoAction(inEstado) {
    return (dispatch) => {
        dispatch(setEstado(inEstado));
    };
}
const setEstado = (inEstado) => ({
    type: SET_ESTADO_COMPRAMOS_TU_AUTO,
    payload: inEstado,
});

/**
 *
 * @param {*} inCiudad
 * @returns
 */
export function setCiudadAction(inCiudad) {
    return (dispatch) => {
        dispatch(setCiudad(inCiudad));
    };
}
const setCiudad = (inCiudad) => ({
    type: SET_CIUDAD_COMPRAMOS_TU_AUTO,
    payload: inCiudad,
});

/**
 *
 * @param {*} inIdConcesionario
 * @returns
 */
export function setIdConcesionarioAction(inIdConcesionario) {
    return (dispatch) => {
        dispatch(setIdConcesionario(inIdConcesionario));
    };
}
const setIdConcesionario = (inIdConcesionario) => ({
    type: SET_ID_CONCESIONARIO_COMPRAMOS_TU_AUTO,
    payload: inIdConcesionario,
});

/**
 *
 * @param {*} inConcesionario
 * @returns
 */
export function setConcesionarioAction(inConcesionario) {
    return (dispatch) => {
        dispatch(setConcesionario(inConcesionario));
    };
}
const setConcesionario = (inConcesionario) => ({
    type: SET_CONCESIONARIO_COMPRAMOS_TU_AUTO,
    payload: inConcesionario,
});

/**
 *
 * @param {*} inAnoVehiculo
 * @returns
 */
export function setAnoVehiculoAction(inAnoVehiculo) {
    return (dispatch) => {
        dispatch(setAnoVehiculo(inAnoVehiculo));
    };
}
const setAnoVehiculo = (inAnoVehiculo) => ({
    type: SET_ANO_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    payload: inAnoVehiculo,
});

/**
 *
 * @param {*} inModeloVehiculo
 * @returns
 */
export function setModeloVehiculoAction(inModeloVehiculo) {
    return (dispatch) => {
        dispatch(setModeloVehiculo(inModeloVehiculo));
    };
}
const setModeloVehiculo = (inModeloVehiculo) => ({
    type: SET_MODELO_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    payload: inModeloVehiculo,
});

/**
*
* @param {*} inColorVehiculo
* @returns
*/
export function setColorVehiculoAction(inColorVehiculo) {
    return (dispatch) => {
        dispatch(setColorVehiculo(inColorVehiculo));
    };
}
const setColorVehiculo = (inColorVehiculo) => ({
    type: SET_COLOR_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    payload: inColorVehiculo,
});

/**
*
* @param {*} inMarcaVehiculo
* @returns
*/
export function setMarcaVehiculoAction(inMarcaVehiculo) {
    return (dispatch) => {
        dispatch(setMarcaVehiculo(inMarcaVehiculo));
    };
}
const setMarcaVehiculo = (inMarcaVehiculo) => ({
    type: SET_MARCA_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    payload: inMarcaVehiculo,
});

/**
*
* @param {*} inVersionVehiculo
* @returns
*/
export function setVersionVehiculoAction(inVersionVehiculo) {
    return (dispatch) => {
        dispatch(setVersionVehiculo(inVersionVehiculo));
    };
}
const setVersionVehiculo = (inVersionVehiculo) => ({
    type: SET_VERSION_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    payload: inVersionVehiculo,
});

/**
*
* @param {*} inKilometrajeVehiculo
* @returns
*/
export function setKilometrajeVehiculoAction(inKilometrajeVehiculo) {
    return (dispatch) => {
        dispatch(setKilometrajeVehiculo(inKilometrajeVehiculo));
    };
}
const setKilometrajeVehiculo = (inKilometrajeVehiculo) => ({
    type: SET_KILOMETRAJE_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
    payload: inKilometrajeVehiculo,
});

/**
 *
 * @param {*} inComentarios
 * @returns
 */
export function setComentariosAction(inComentarios) {
    return (dispatch) => {
        dispatch(setComentarios(inComentarios));
    };
}
const setComentarios = (inComentarios) => ({
    type: SET_COMENTARIOS_COMPRAMOS_TU_AUTO,
    payload: inComentarios,
});

/**
 *
 * @param {*} inAvisosDePrivacidad
 * @returns
 */
export function setAvisosDePrivacidadAction(inAvisosDePrivacidad) {
    return (dispatch) => {
        dispatch(setAvisosDePrivacidad(inAvisosDePrivacidad));
    };
}
const setAvisosDePrivacidad = (inAvisosDePrivacidad) => ({
    type: SET_AVISO_PRIVACIDAD_COMPRAMOS_TU_AUTO,
    payload: inAvisosDePrivacidad,
});

/**
 *
 * @param {*} inTerminosCondiciones
 * @returns
 */
export function setTerminosCondicionesAction(inTerminosCondiciones) {
    return (dispatch) => {
        dispatch(setTerminosCondiciones(inTerminosCondiciones));
    };
}
const setTerminosCondiciones = (inTerminosCondiciones) => ({
    type: SET_TERMINOS_Y_CONDICIONES_COMPRAMOS_TU_AUTO,
    payload: inTerminosCondiciones,
});

/**
 *
 * @param {*} inLegales
 * @returns
 */
export function setLegalesAction(inLegales) {
    return (dispatch) => {
        dispatch(setLegales(inLegales));
    };
}
const setLegales = (inLegales) => ({
    type: SET_LEGALES_COMPRAMOS_TU_AUTO,
    payload: inLegales,
});

/**
 *
 * @param {*} inUrlHomeDealer
 * @returns
 */
export function setUrlHomeDealerAction(inUrlHomeDealer) {
    return (dispatch) => {
        dispatch(setUrlHomeDealer(inUrlHomeDealer));
    };
}
const setUrlHomeDealer = (inUrlHomeDealer) => ({
    type: SET_URL_HOME_DEALER_COMPRAMOS_TU_AUTO,
    payload: inUrlHomeDealer,
});